import { forwardRef } from 'react';
// icons
import { Icon } from '@iconify/react';
// @mui
import { Box, BoxProps } from '@mui/material';
//
import { IconifyProps } from './types';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  icon: IconifyProps;
}

const Iconify = forwardRef<SVGElement, Props>(({ icon, width = 20, sx, ...other }, ref) => (
  <Box
    ref={ref}
    sx={{
      width: width,
      height: width,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      ...sx,
    }}
    {...other}
  >
    <Icon icon={icon} width="100%" height="100%" />
  </Box>
));

export default Iconify;
